if (!customElements.get('syun-hero-slider')) {
  customElements.define('syun-hero-slider', class SyunHeroSlider extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.stop();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionOverride = false;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.suppressClickUntil = 0;
      this.show(0, false);
      if (this.slides.length < 2) return;
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true), options);
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true), options));
      this.querySelector('[data-toggle]')?.addEventListener('click', () => this.toggle(), options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.stop();
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.start();
      }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        if (!this.focused) this.start();
      }, options);
      document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.start(), options);
      this.motion.addEventListener('change', () => {
        this.motionOverride = false;
        this.restart();
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }, options);
      const viewport = this.querySelector('[data-viewport]');
      viewport?.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || !event.isPrimary) return;
        this.touch = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, options);
      viewport?.addEventListener('pointerup', (event) => {
        if (!this.touch || this.touch.id !== event.pointerId) return;
        const dx = event.clientX - this.touch.x;
        const dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        this.suppressClickUntil = Date.now() + 500;
        this.show(this.index + (dx < 0 ? 1 : -1), true);
      }, options);
      viewport?.addEventListener('pointercancel', () => { this.touch = null; }, options);
      viewport?.addEventListener('click', (event) => {
        if (Date.now() >= this.suppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', (event) => {
        const selected = this.slides.indexOf(event.target.closest('[data-slide]'));
        if (selected >= 0) this.show(selected, true);
      }, options);
      this.start();
    }
    disconnectedCallback() {
      this.stop();
      this.events?.abort();
    }
    show(nextIndex, manual) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      if (manual) this.paused = true;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('is-previous', this.slides.length > 2 && index === (this.index - 1 + this.slides.length) % this.slides.length);
        slide.classList.toggle('is-next', this.slides.length > 1 && index === (this.index + 1) % this.slides.length);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
      });
      const count = this.querySelector('[data-count]');
      if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
      const status = this.querySelector('[data-status]');
      if (manual && status) status.textContent = `スライド${this.index + 1} / ${this.slides.length}`;
      this.restart();
    }
    enabled() {
      return this.autoplay && !this.paused && (!this.motion.matches || this.motionOverride);
    }
    updateToggle() {
      const toggle = this.querySelector('[data-toggle]');
      if (!toggle) return;
      const enabled = this.enabled();
      toggle.textContent = enabled ? '停止' : '再生';
      toggle.setAttribute('aria-label', enabled ? '自動切替を停止' : '自動切替を再開');
    }
    start() {
      this.updateToggle();
      if (this.slides.length < 2 || !this.enabled() || this.hovered || this.focused || document.hidden || this.timer) return;
      this.timer = window.setInterval(() => this.show(this.index + 1, false), this.interval);
    }
    stop() { window.clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
    toggle() {
      const play = !this.enabled();
      this.paused = !play;
      if (play) this.motionOverride = true;
      this.restart();
    }
  });
}
